import { FC, ReactNode, useEffect, useState } from 'react';
import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import CloseCircle from '../Icons/CloseCircle';
import { CbSelect } from '../CbSelect';
export interface CbFilterBoxProps extends BoxProps {
  staleFilters: string[] | null;
  dropdownFilters: string[];
  placeholder?: string;
  width?: string;
  handleActiveFilterChange: (filters: string[]) => void;
}
interface TagRowProps extends BoxProps {
  children: ReactNode;
}
const TagRow: FC<TagRowProps> = ({
  children,
  ...rest
}) => <Box display="flex" flexWrap="wrap" justifyContent="left" {...rest} data-sentry-element="Box" data-sentry-component="TagRow" data-sentry-source-file="CbFilterBox.tsx">
    {children}
  </Box>;
export const CbFilterBox: FC<CbFilterBoxProps> = ({
  staleFilters,
  dropdownFilters,
  placeholder,
  width,
  handleActiveFilterChange,
  ...props
}) => {
  const [possibleFilters, setPossibleFilters] = useState(dropdownFilters);
  useEffect(() => {
    const filtersInDropdown = dropdownFilters.filter((value, i) => {
      return value !== staleFilters?.[i];
    });
    setPossibleFilters(filtersInDropdown);
  }, [dropdownFilters]);
  const possibleColors = ['venasaur.500', 'chonky.500', 'luigisPants.500', 'kirby.500', 'samus.500', 'cloud.500', 'venasaur.600', 'chonky.600', 'luigisPants.600', 'kirby.600', 'samus.600', 'cloud.600'];
  const onFilterAdd = (filterToAdd: string) => {
    const filtersInDropdown = possibleFilters.filter(value => {
      return value !== filterToAdd;
    });
    let newActiveFilters;
    if (staleFilters) {
      newActiveFilters = [...staleFilters, filterToAdd];
    } else {
      newActiveFilters = [filterToAdd];
    }
    setPossibleFilters(filtersInDropdown);
    handleActiveFilterChange(newActiveFilters);
  };
  const onFilterRemove = (filterToRemove: string) => {
    possibleFilters.unshift(filterToRemove);
    let newActiveFilters;
    if (staleFilters) {
      newActiveFilters = staleFilters.filter(value => {
        return value !== filterToRemove;
      });
    } else {
      newActiveFilters = [];
    }
    handleActiveFilterChange(newActiveFilters);
  };
  return <Box {...props} data-sentry-element="Box" data-sentry-component="CbFilterBox" data-sentry-source-file="CbFilterBox.tsx">
      <Text marginLeft={2} marginBottom={2} color="text.secondary" fontWeight={'bold'} data-sentry-element="Text" data-sentry-source-file="CbFilterBox.tsx">
        {placeholder}
      </Text>
      <CbSelect onChange={onFilterAdd} options={possibleFilters} placeholder="Select" value={'Select'} data-sentry-element="CbSelect" data-sentry-source-file="CbFilterBox.tsx" />
      <br />
      <TagRow data-sentry-element="TagRow" data-sentry-source-file="CbFilterBox.tsx">
        {staleFilters?.map((filter, i) => {
        const tagColor = possibleColors[i];
        return <Flex key={`${filter} ${i}`} alignItems="center" paddingX="8px" paddingY="2px" borderWidth="1px" borderRadius="8px" width="fit-content" borderColor={tagColor} marginRight={4} marginBottom={4}>
              <Box as="button" onClick={() => onFilterRemove(filter)}>
                <CloseCircle color={tagColor} height="16px" marginRight={2} />
              </Box>
              <Text color={tagColor} fontSize="sm">
                {filter}
              </Text>
            </Flex>;
      })}
      </TagRow>
    </Box>;
};